import {
    Component,
    ElementRef,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    selector: 'white-label-notification-ad',
    templateUrl: './notification-widget.component.html',
    standalone: true,
    animations: [
        trigger('slideInOut', [
            state('hidden', style({ transform: 'translateX(100%)', opacity: 0 })),
            state('visible', style({ transform: 'translateX(0)', opacity: 1 })),
            transition('hidden => visible', [
                animate('1s ease-in')
            ]),
            transition('visible => hidden', [
                animate('1s ease-out')
            ])
        ])
    ],
    styles: `.notification {
      position: fixed;
      top: 2vh;
      right: 2vh;
      background-color: var(--card);
      color: white;
      padding: 1vh;
      border-radius: 8px;
      font-size: 2vh;
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
      max-width: 30vw;
      font-family: Arial, sans-serif;
    }

    .logo {
      width: 4vw;
      margin-right: 1vh;
    }

    .content {
      flex-grow: 1;
    }`
})
export class NotificationWidgetComponent implements OnInit {
    @Input() message: string | undefined = '';
    @Input() title: string = '';
    @Input() logo: string | undefined = '';
    @Output() onEnd: EventEmitter<any> = new EventEmitter();

    @Input() position: number = 0;

    constructor(private host: ElementRef<HTMLElement>) {

    }

    ngOnInit(): void {
        setTimeout(()=>{
            this.showNotification();
        },200)
    }
    isVisible = false;

    showNotification() {
        this.isVisible = true;
        setTimeout(() => {
            this.isVisible = false;
            setTimeout(() => {
                this.host.nativeElement.remove();
            }, 2000)
        }, 15000); // 15 seconds

        setTimeout(() => {
            this.onEnd.emit(this.position);
        }, 17000)
    }
}